import type { App } from "vue";

import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";

export const registerPrimeVue = (app: App): void => {
  const CustomPreset = definePreset(Aura, {
    semantic: {
      primary: {
        50: "{yellow.50}",
        100: "{yellow.100}",
        200: "{yellow.200}",
        300: "{yellow.300}",
        400: "{yellow.400}",
        500: "{yellow.500}",
        600: "{yellow.600}",
        700: "{yellow.700}",
        800: "{yellow.800}",
        900: "{yellow.900}",
        950: "{yellow.950}",
      },
      green: {
        50: "hsl(85deg 76% 95%)",
        100: "hsl(86deg 75% 89%)",
        200: "hsl(88deg 73% 80%)",
        300: "hsl(88deg 69% 67%)",
        400: "hsl(89deg 64% 55%)",
        500: "hsl(90deg 66% 42%)",
        600: "hsl(91deg 69% 35%)",
        700: "hsl(92deg 64% 27%)",
        800: "hsl(93deg 57% 23%)",
        900: "hsl(93deg 50% 20%)",
        950: "hsl(95deg 65% 10%)",
      },
    },
  });
  const cspNonceMeta = document.querySelector('meta[name="csp-nonce"]');
  const cspNonce = cspNonceMeta ? cspNonceMeta.getAttribute("content") : null;
  app.use(PrimeVue, {
    csp: {
      nonce: cspNonce,
    },
    // ripple: true,
    theme: {
      preset: CustomPreset,
      options: {
        prefix: "p",
        darkModeSelector: ".dark",
        cssLayer: {
          name: "primevue",
          order: "tailwind-base, primevue, tailwind-utilities, components",
        },
        zIndex: {
          modal: 1100, // dialog,sidebar
          overlay: 1000, // dropdown, overlaypanel
          menu: 1000, // overlay menus
          tooltip: 1100, // tooltip
        },
      },
      unstyled: true,
    },
  });
  app.use(ToastService);
  app.use(ConfirmationService);
  app.use(DialogService);
  app.directive("tooltip", Tooltip);
};
